import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Services
import { PopupGuardService } from './services/popup-guard.service';

// Components
import { PopupWrapperComponent } from './components/popup-wrapper/popup-wrapper.component';
import { MailEditorPopupComponent } from './components/mail-editor-popup/mail-editor-popup.component';
import { FullFormPopupComponent } from './components/full-form-popup/full-form-popup.component';
import { authGuard } from '@frontendlib/common/guards/auth.guard';
import { accountKindReadyGuard } from '@modules/common/services/account-kind-ready.guard';

/** The route that opens one item of any type in its own window; the component reads these two parameters by name. */
export const FULL_FORM_POPUP_PATH = ':stitch-type/:id';

export const popupRoutes: Routes = [
  {
    path: 'compact',
    canActivate: [authGuard, accountKindReadyGuard],
    canDeactivate: [PopupGuardService],
    component: PopupWrapperComponent,
    children: [
      { path: 'mail/compose', canActivate: [authGuard], component: MailEditorPopupComponent },
      { path: FULL_FORM_POPUP_PATH, canActivate: [authGuard], component: FullFormPopupComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(popupRoutes)],
  exports: [RouterModule],
})
export class PopupRoutingModule {}
